// @flow

import * as React from 'react';

import IconControlFactory from './icons/IconUiFactory';
import IconButton from './buttons/IconButton';
import styles from './CloseButton.module.css';

type Props = {
  onClick: Function,
};

export default ({ onClick }: Props) => (
  <div className={styles.close}>
    <IconButton onClick={onClick}>
      {IconControlFactory({ id: 'close' })}
    </IconButton>
  </div>
);
